import { CALL_ME_BANNER_FORM_URL, SLUG_MACROS } from '../constants';

export function getCallMeBannerFormUrl(slug: string) {
    return CALL_ME_BANNER_FORM_URL.replace(SLUG_MACROS, slug);
}
